import { Pipe, PipeTransform } from '@angular/core';
import { FilterSchema, SelectFilterSchema } from './resource-table.component';

@Pipe({
  name: 'resourceTableFilterOptions',
  standalone: true,
})
export class ResourceTableFilterOptionsPipe implements PipeTransform {
  transform(
    value: SelectFilterSchema['options'] | undefined,
    schema: FilterSchema | undefined,
  ): {
    value: string | number;
    label: string;
  }[] {
    if (!value) return [];

    const selectSchemaOptions = schema as SelectFilterSchema | undefined;

    if (value instanceof Map) {
      return Array.from(value.entries())
        .map(([rawValue, { label }]) => {
          if (rawValue == '_default') {
            if (selectSchemaOptions?.hideDefault === true) {
              return null;
            }

            return {
              value: selectSchemaOptions?.defaultValue ?? '',
              label,
            };
          }

          return {
            value: this.parseValue(rawValue),
            label,
          };
        })
        .filter(Boolean) as {
        value: string | number;
        label: string;
      }[];
    }

    return value;
  }

  private parseValue(value: any) {
    if (typeof value !== 'string') {
      return value;
    }

    if (['true', 'false'].includes(value)) {
      return value === 'true';
    }

    if (!isNaN(Number(value))) {
      return Number(value);
    }

    return value;
  }
}
